const LIVE_OFF = new Set(['false', '0', 'off', 'no']);

export const isSubastaLiveEnabled = () => {
  const raw = import.meta.env.VITE_FF_SUBASTA_LIVE;
  if (raw == null || String(raw).trim() === '') {
    return true;
  }
  return !LIVE_OFF.has(String(raw).toLowerCase());
};

export const getAuctionSocketUrl = () => import.meta.env.VITE_SOCKET_API || '';
